import React, { Component } from 'react'
import { bindActionCreators, compose } from 'redux'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { FormattedMessage, injectIntl } from 'react-intl'
import { Formik, withFormik } from 'formik'
import Yup from 'yup'

import sharedMessages from 'containers/sharedMessages'
import { isBackButtonAvailable, getAddress, getisAddressValidated, getMatchedAddresses } from 'rootReducer'
import { emailValidator } from 'utils/validators'
import { URLS } from 'containers/constants'
import { setActiveCartTab } from 'containers/actionCreators'
import { setAddressDetails } from './actions'
import { computeTaxes, setAddressValidated, addressComplete, retrieveAddress } from '../actions'
import { AddressForm } from './AddressForm'
import messages from './messages'

const AddressFooter = styled.div`
  border-top: solid 1px lightgray;
  padding: 5px;
  width: calc(100% - 10px);
`

class AddressContainer extends Component {
  static propTypes = {
    // addressActions: PropTypes.object,
    touched: PropTypes.object,
    errors: PropTypes.object,
    handleBlur: PropTypes.func,
    handleChange: PropTypes.func,
    intl: PropTypes.object,
    setAddressDetails: PropTypes.func,
    setAddressValidated: PropTypes.func,
    computeTaxes: PropTypes.func,
    addressComplete: PropTypes.func,
    retrieveAddress: PropTypes.func,
    matchedAddresses: PropTypes.array,
    history: PropTypes.object,
    isAddressValidated: PropTypes.bool,
    address: PropTypes.shape({
      firstName: PropTypes.string,
      lastName: PropTypes.string,
      email: PropTypes.string,
      addressLine1: PropTypes.string.isRequired,
      addressLine2: PropTypes.string,
      addressLine3: PropTypes.string.isRequired,
      postalCode: PropTypes.string.isRequired,
      province: PropTypes.string.isRequired,
    }),
  }

  constructor(props) {
    super(props)
    this.state = {
      fields: {
        [sharedMessages.firstName.sid]: props.address.firstName || '',
        [sharedMessages.lastName.sid]: props.address.lastName || '',
        [sharedMessages.email.sid]: props.address.email || '',
        [messages.addressLine1.sid]: props.address.addressLine1 || '',
        [messages.addressLine2.sid]: props.address.addressLine2 || '',
        [messages.city.sid]: props.address.addressLine3 || '',
        [messages.postalCode.sid]: props.address.postalCode || '',
        [messages.country.sid]: props.intl.formatMessage({ id: sharedMessages.canadaLabel.id }),
        [messages.province.sid]: props.address.province || '',
        [messages.provinceSelectList.sid]: props.intl.formatMessage({ id: messages.provinceSelectList.id }),
      },
    }
  }
  handleValidation = values =>
    Yup.object().shape({
      [sharedMessages.firstName.sid]: Yup.string().max(60, this.props.intl.formatMessage({ id: sharedMessages.firstNameLengthValidation.id }))
        .required(this.props.intl.formatMessage({ id: sharedMessages.firstNameValidationEmpty.id })),

      [sharedMessages.lastName.sid]: Yup.string().max(60, this.props.intl.formatMessage({ id: sharedMessages.lastNameLengthValidation.id }))
        .required(this.props.intl.formatMessage({ id: sharedMessages.lastNameValidationEmpty.id })),

      [sharedMessages.email.sid]: Yup.string()
        .email(this.props.intl.formatMessage({ id: sharedMessages.emailValidationIncorrect.id }))
        .required(this.props.intl.formatMessage({ id: sharedMessages.emailValidationEmpty.id })),

      [messages.addressLine1.sid]: Yup.string().max(60, this.props.intl.formatMessage({ id: messages.addressLine1LengthValidation.id }))
        .required(this.props.intl.formatMessage({ id: messages.addressLine1ValidationEmpty.id })),

      [messages.addressLine2.sid]: Yup.string().max(60, this.props.intl.formatMessage({ id: messages.addressLine2LengthValidation.id })),

      [messages.city.sid]: Yup.string().max(50, this.props.intl.formatMessage({ id: messages.cityLengthValidation.id }))
        .required(this.props.intl.formatMessage({ id: messages.cityValidationEmpty.id })),

      [messages.provinceSelectList.sid]: Yup.string()
        .required(this.props.intl.formatMessage({ id: messages.provinceSelectListValidationEmpty.id })),

      [messages.postalCode.sid]: Yup.string().matches(
        /[A-Za-z]\d[A-Za-z] ?\d[A-Za-z]\d/,
        this.props.intl.formatMessage({ id: messages.postalCodeValidationInvalid.id })
      ).required(this.props.intl.formatMessage({ id: messages.postalCodeValidationEmpty.id })),
    })

  handleSubmit = (values, props) => {
    console.log(values)
    this.props.setAddressDetails(values)
    this.props.setAddressValidated(true)
    this.props.computeTaxes()
  }

  render() {
    const {
      props: {
        touched, errors, handleBlur, handleChange, isAddressValidated, address,
      },
    } = this
    return (<Formik
      initialValues={this.state.fields}
      onSubmit={this.handleSubmit}
      render={props => (<AddressForm
        {...props}
        validationSchema={this.handleValidation}
        isAddressValidated={isAddressValidated}
        addressComplete={this.props.addressComplete}
        retrieveAddress={this.props.retrieveAddress}
        matchedAddresses={this.props.matchedAddresses}
        address={address}
      />)}
      validationSchema={this.handleValidation}
      displayName="AddressForm"
    />)
  }
}
const mapStateToProps = state => ({
  isBackButtonAvailable: isBackButtonAvailable(state),
  isAddressValidated: getisAddressValidated(state),
  address: getAddress(state),
  matchedAddresses: getMatchedAddresses(state),
})

/* Using compose so we can clearly see what the AddressContainer is being enhanced with */
export const ConnectedAddressContainer = compose(
  injectIntl,
  connect(mapStateToProps, {
    setAddressDetails, computeTaxes, setAddressValidated, addressComplete, retrieveAddress,
  }),
)(AddressContainer)



// WEBPACK FOOTER //
// ./src/containers/Cart/Address/AddressContainer.js